import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M14.477 1.01c.41.039.803.194 1.128.45l.158.136 5.602 5.375.143.152c.314.368.492.835.492 1.326v12.476C22 22.102 21.015 23 19.871 23H4.13C2.996 23 2 22.091 2 20.925V3.075C2 1.908 2.996 1 4.129 1H14.27zM4.129 2.404c-.426 0-.733.342-.733.671v17.85c0 .328.307.67.733.67H19.87c.437 0 .733-.331.734-.67V9.27h-5.028c-.554 0-1.09-.212-1.492-.597a2.05 2.05 0 0 1-.636-1.479v-4.79zm10.716 4.79a.64.64 0 0 0 .202.463c.135.13.325.208.53.208h4.697l-5.43-5.21z" }, null, -1)
  ]))]))
}
export default { render: render }